
<div class="flex-row ">
  <img
      *ngIf="(matOptionTemplateValuesObs | async)?.imgSrc" [src]="(matOptionTemplateValuesObs | async)?.imgSrc"
      class="option-img height-3"
  />

  
    
  <div class="flex-1">

    <p *ngIf="(matOptionTemplateValuesObs | async)?.title"  class="mat-headline-6 margin-none">{{(matOptionTemplateValuesObs | async)?.title}}
      <span *ngIf="(matOptionTemplateValuesObs | async)?.subtitle" class="mat-body-2">({{(matOptionTemplateValuesObs | async)?.subtitle}})</span>
    </p>

  </div>
</div>
